export const NAVIGATION_CONFIG = {
    PROJECTS: {
        name: 'Projects',
        nameLowercase: 'projects',
        nameSingular: 'Project',
        nameSingularLowercase: 'project',
        path: '/projects',
        aliases: ['/projects'],
    },
    SOLUTIONS: {
        name: 'Workspaces',
        nameLowercase: 'workspaces',
        nameSingular: 'Workspace',
        nameSingularLowercase: 'workspace',
        path: '/workspaces',
        aliases: ['/solutions'],
    },
};

export const generateRedirectRoutes = () => {
    const redirectRoutes = {};

    Object.keys(NAVIGATION_CONFIG).forEach((key) => {
        const config = NAVIGATION_CONFIG[key];
        if (config.aliases && Array.isArray(config.aliases)) {
            config.aliases.forEach((alias, index) => {
                redirectRoutes[`${key}Redirect${index}`] = {
                    from: alias,
                    to: config.path
                };
            });
        }
    });

    return redirectRoutes;
};
